module.exports = __webpack_public_path__ + "img/Atelier_9.fb0ef6af.jpg";